<template>
  <div class="box">
    <headerComponent></headerComponent>
    <section id="hero" class="mt-4" style="min-height: 494px">
      <div class="container">
        <div class="container">
          <div class="row d-flex">
            <div class="col-lg-6 text order-2 order-lg-1">
              <h3>{{username}}免费用? 是真的！<br>只要将{{username}}推荐给您的朋友们，即可长期免费用啦！</h3>
              <div class="mt-4">
                <div class="text-left">
                  <p class="hero-text mb-2"><b>第一步</b> 登录{{username}}账号，点击“长期免费使用计划”按钮。</p>
                  <p class="hero-text mb-2"><b>第二步</b> 好友通过您的分享注册成功并领取免费体验，即可领取3天会员或4k VR高级体验。</p>
                  <p class="hero-text mb-2"><b>第三步</b> 好友订购任何产品，您都将可领取30天的会员期或15天的4K VR高级体验（累计不封顶）。</p>
                  <p class="hero-text mb-0"><b>第四步</b> 您可以在后台，通过”分享记录“查看或领取您的奖励。</p>
                </div>

                <div class="CTA mt-4">
                  <a @click="$router.push({name:'login',params:{status:'reg'}})" class="btn btn-primary btn-shadow btn-gradient link-scroll mr-4">新用户注册</a>
                  <a @click="$router.push({name:'login',params:{status:'login'}})" class="btn btn-outline-primary">老用户登录</a>
                </div>
              </div>
            </div>
            <div class="col-lg-6 order-1 order-lg-2 mt-4 share-img">

              <img src="../assets/share.jpeg" alt="..." class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </section>
    <footerComponent></footerComponent>
  </div>
</template>

<script>
import headerComponent from "@/components/header";
import footerComponent from "@/components/footer";
import {getUser} from "@/axios/token";
export default {
  name: "sharePage",
  components:{headerComponent, footerComponent},
  data(){
    return{
      username:getUser(),
    }
  },
}


</script>

<style scoped>
.info-btn{
  background-color: #e9f3ff;
  color: #2d8eff;
  margin: 5px;
  padding: .55rem 0rem;
}
@media (min-width: 0px){
  section {
    padding: 20px 0;
  }
  .share-img{
    margin-top: 20px;
    margin-bottom: 20px;
    z-index: -1;
  }
  #hero{
    margin-bottom: 30px;
  }
}
@media (min-width: 768px){
  section {
    padding: 80px 0;
  }
  #hero{
    margin-bottom: 0;
  }
}
</style>